import {
    DependenciesPayload,
    VehicleState,
} from '@sxm-de/dev-kits/web-sdk/types';
import { mapVehicleState } from '../mappers/map-vehicle-state';
import { getAccessToken } from '@sxm-de/dev-kits/web-sdk/utils';

/**
 * Looks up a device by radio id in Atlas first, then in SMS.
 */
export async function getDeviceByRadioId(
    { radioId }: { radioId: string },
    { atlasSdk, microservicesSdk }: DependenciesPayload,
): Promise<VehicleState> {
    try {
        /**
         * Check Atlas first.
         */
        const deviceAtlas = await atlasSdk.domains.user.deviceStatusByRadioId({
            request: { radioId },
            accessToken: getAccessToken(),
        });
        return {
            ...deviceAtlas,
            deviceSource: 'ATLAS',
        };
    } catch (error: any) {
        try {
            /**
             * Check SMS.
             */
            const radio = await microservicesSdk.domains.device.validate({
                radioId,
            });
            const radioInfo = await microservicesSdk.domains.device.info({
                radioId: radio.last4DigitsOfRadioId,
            });
            return {
                ...mapVehicleState(radioInfo),
                radioId,
            };
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    }
}
